import { defineComponent as _defineComponent } from 'vue'
import { format } from 'date-fns';
import { computed } from '@nuxtjs/composition-api';
import { getUniversityPath } from '@/utils/routes';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import PencilIcon from '@/components/partials/public-portfolio/PublicPortfolioEducationHistory/images/pencil.vue.svg';
import type { EducationHistory } from '@/types/graphql';

type PublicPortfolioEducationHistoryProps = {
  educationHistory: EducationHistory;
  editable?: boolean;
};
type PublicPortfolioEducationHistoryEmits = {
  (event: 'edit', payload: EducationHistory): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioEducationHistory',
  props: {
    educationHistory: null,
    editable: { type: Boolean, default: false }
  },
  emits: ["edit"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'edit', payload: EducationHistory): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { educationHistory: EducationHistory, editable: boolean };




const formatDate = (date: string, dateFormat = 'MMM yyyy') => format(new Date(date), dateFormat);

const university = computed(() => props.educationHistory.university?.parent ?? props.educationHistory.university);
const link = computed(() => (university.value?.verified ? getUniversityPath(university.value?.slug ?? '') : null));
const name = computed(() => props.educationHistory.university?.name);
const image = computed(() => university.value?.logoUrl);
const dateFormat = computed(() => (props.educationHistory.manuallyEdited ? 'MMM yyyy' : 'yyyy'));
const startDate = computed(() =>
  props.educationHistory.startDate ? formatDate(props.educationHistory.startDate, dateFormat.value) : '-',
);
const endDate = computed(() =>
  props.educationHistory.endDate ? formatDate(props.educationHistory.endDate, dateFormat.value) : 'Present',
);
const containerComponent = computed(() => (link.value ? 'NuxtLink' : 'div'));
const containerStyles = computed(() => ({
  'public-portfolio-education-history__container': true,
  'public-portfolio-education-history__container--link': Boolean(link.value),
}));

function handleEdit() {
  emit('edit', props.educationHistory);
}

return { __sfc: true,props, emit, formatDate, university, link, name, image, dateFormat, startDate, endDate, containerComponent, containerStyles, handleEdit, BravadoButtonV3, PencilIcon }
}

})